"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.useGetter = function (value) {
    var ref = react_1.default.useRef(value);
    ref.current = value;
    return react_1.default.useCallback(function () { return ref.current; }, []);
};
var thunk = function (fn) { return ({ fn: fn, isThunk: true }); };
var merge = function (x) { return function (o) {
    return typeof x === 'function' ? __assign(__assign({}, o), x(o)) : __assign(__assign({}, o), x);
}; };
exports.useLogic = function (fn, initial) {
    var actionsRef = react_1.default.useRef();
    var _a = react_1.default.useState(function () {
        var config = fn({ thunk: thunk, merge: merge });
        var actions = {};
        var _loop_1 = function (k) {
            var entry = config[k];
            var action = entry.isThunk
                ? function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return entry.fn.apply(entry, args)(actions, getState);
                }
                : function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return setState(entry.apply(void 0, args));
                };
            actions[k] = action;
        };
        for (var k in config) {
            _loop_1(k);
        }
        actionsRef.current = actions;
        return typeof initial === 'function' ? initial() : initial;
    }), state = _a[0], setState = _a[1];
    var getState = exports.useGetter(state);
    return [state, actionsRef.current];
};
exports.usePrevious = function (value) {
    var ref = react_1.default.useRef();
    react_1.default.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
exports.useEffectPrevious = function (fn, deps) {
    var prevs = exports.usePrevious(deps);
    var getPrevs = exports.useGetter(prevs);
    react_1.default.useEffect(function () {
        fn(getPrevs() || []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
exports.useUpdate = function () {
    var _a = react_1.default.useState(0), update = _a[1];
    return function () { return update(function (x) { return (x + 1) & 0xffffffff; }); }; // Prevents reaching MAX_SAFE_INTEGER (can this ever be possible?)
};
